"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountShape = void 0;
const account_1 = require("../../../../account");
const logs_1 = require("@ledgerhq/logs");
const api_1 = require("./api");
const lodash_1 = require("lodash");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const consts_1 = require("../../consts");
const operation_1 = require("../../../../operation");
const utils_1 = require("../../utils");
const mapTxToOps = (accountId, address, fee = consts_1.ICP_FEES) => {
    return (txInfo) => {
        const ops = [];
        const ownerOperation = txInfo.transaction.operations.find(cur => cur.account.address === address);
        const counterOperation = txInfo.transaction.operations.find(cur => cur.account.address !== address);
        if (!ownerOperation || !counterOperation)
            return ops;
        const timeStamp = txInfo.transaction.metadata.timestamp;
        const amount = (0, bignumber_js_1.default)(ownerOperation.amount.value);
        const hash = txInfo.transaction.transaction_identifier.hash;
        const fromAccount = amount.isPositive()
            ? counterOperation.account.address
            : ownerOperation.account.address;
        const toAccount = amount.isNegative()
            ? counterOperation.account.address
            : ownerOperation.account.address;
        const memo = txInfo.transaction.metadata.memo.toString();
        const blockHeight = txInfo.transaction.metadata.block_height;
        const date = new Date((0, utils_1.normalizeEpochTimestamp)(timeStamp.toString()));
        const value = amount.abs();
        const feeToUse = (0, bignumber_js_1.default)(fee);
        const isSending = amount.isNegative();
        const isReceiving = amount.isPositive();
        if (isSending) {
            ops.push({
                id: (0, operation_1.encodeOperationId)(accountId, hash, "OUT"),
                hash,
                type: "OUT",
                value: value.plus(feeToUse),
                fee: feeToUse,
                blockHeight,
                blockHash: null,
                accountId,
                senders: [fromAccount],
                recipients: [toAccount],
                date,
                extra: {
                    memo,
                },
            });
        }
        if (isReceiving) {
            ops.push({
                id: (0, operation_1.encodeOperationId)(accountId, hash, "IN"),
                hash,
                type: "IN",
                value,
                fee: feeToUse,
                blockHeight,
                blockHash: null,
                accountId,
                senders: [fromAccount],
                recipients: [toAccount],
                date,
                extra: {
                    memo,
                },
            });
        }
        return ops;
    };
};
const getAccountShape = (info) => __awaiter(void 0, void 0, void 0, function* () {
    const { address, currency, derivationMode, rest = {}, initialAccount } = info;
    const publicKey = reconciliatePublicKey(rest.publicKey, initialAccount);
    const accountId = (0, account_1.encodeAccountId)({
        type: "js",
        version: "2",
        currencyId: currency.id,
        xpubOrAddress: publicKey,
        derivationMode,
    });
    (0, logs_1.log)("debug", `Generation account shape for ${address}`);
    const blockHeight = yield (0, api_1.fetchBlockHeight)();
    const balanceResp = yield (0, api_1.fetchBalances)(address);
    const balance = balanceResp.balances[0];
    const txns = yield (0, api_1.fetchTxns)(address);
    const result = {
        id: accountId,
        balance: (0, bignumber_js_1.default)(balance.value),
        spendableBalance: (0, bignumber_js_1.default)(balance.value),
        operations: (0, lodash_1.flatMap)(txns.transactions.reverse(), mapTxToOps(accountId, address)),
        blockHeight: blockHeight.current_block_identifier.index,
        operationsCount: txns.transactions.length,
        xpub: publicKey,
    };
    return result;
});
exports.getAccountShape = getAccountShape;
function reconciliatePublicKey(publicKey, initialAccount) {
    if (publicKey)
        return publicKey;
    if (initialAccount) {
        const { xpubOrAddress } = (0, account_1.decodeAccountId)(initialAccount.id);
        return xpubOrAddress;
    }
    throw new Error("publicKey wasn't properly restored");
}
//# sourceMappingURL=account.js.map